module.exports = __webpack_public_path__ + "img/0125be9.svg";